<jqxWindow #form [theme]="theme" [position]="getFormPos(form)" [zIndex]="999" [width]="1275" [maxWidth]="'100vw'"
    [maxHeight]="'100vh'" [height]="520" [autoOpen]="true" [showCloseButton]="true" [showCollapseButton]="true"
    [resizable]="false" (onClose)="onClose()">
    <div class="formHeader" style="overflow-x: hidden;">
        {{translate('Asociar_cerradura')}}
    </div>
    <div class="form" style="float:left; overflow-x: hidden;">
        <div style="width: 100%;height: 410px; display: flex; flex-direction: row; gap: 15px;">
            <div style="width:67%">
                <div>
                    {{translate('Calendarios')}}
                </div>
                <jqxGrid #myGrid [theme]="theme" [width]="735" [height]="440" [source]="dataAdapter"
                    [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="true"
                    [columns]="columnCalendar" [showrowlines]="false" [showcolumnlines]="true" [pageable]="false"
                    [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
                    [showaggregates]="true" [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true"
                    [editable]="false" (onRowclick)="onRowClick($event)">
                </jqxGrid>
            </div>
            <div style="width:46%;">
                <div>
                    {{translate('Cerradura')}}
                </div>
                <jqxGrid id="grid1" #myGridLock [theme]="theme" [width]="'100%'" [height]="'50%'"
                    [source]="dataAdapterLock" [columnsresize]="true" [localization]="langGrid" [filterable]="true"
                    [showfilterrow]="true" [columns]="columnLock" [showrowlines]="false" [showcolumnlines]="true"
                    [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
                    [showaggregates]="true" [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true"
                    [editable]="false" [selectionmode]="'checkbox'" (onRowselect)="onSelectV2($event, 'grid1')">
                </jqxGrid>
                <div style="display: flex; flex-direction: column;margin-left: 42%;">
                    <div>
                        <jqxButton style="float:left; clear: both; margin-right: 6px;" [width]='25' [height]='26'
                            [textImageRelation]='"imageAfterText"' [textPosition]='"left"' [imgPosition]='"right"'
                            [imgSrc]='"/assets/images/arriba.png"' (onClick)="onMasClick($event)">
                        </jqxButton>
                        <jqxButton style="gap: 5px;" [width]='25' [height]='26' [textImageRelation]='"imageBeforeText"'
                            [textPosition]='"right"' [imgPosition]='"left"' [imgSrc]='"/assets/images/abajo.png"'
                            (onClick)="onMenosClick($event)">
                        </jqxButton>
                    </div>
                </div>
                <div>
                    {{translate('Cerraduras_disponible')}}
                </div>
                <jqxGrid id="grid2" #myGridLockFree [theme]="theme" [width]="'100%'" [height]="'50%'"
                    [source]="dataAdapterLockFree" [columnsresize]="true" [localization]="langGrid" [filterable]="true"
                    [showfilterrow]="false" [columns]="columnLock" [showrowlines]="false" [showcolumnlines]="true"
                    [pageable]="false" [sortable]="true" [altrows]="true" [showstatusbar]="true" [statusbarheight]="20"
                    [showaggregates]="true" [rowsheight]="20" [columnsheight]="20" [enabletooltips]="true"
                    [showfilterrow]="true" [editable]="false" [selectionmode]="'checkbox'"
                    (onRowselect)="onSelectV2($event, 'grid2')">
                </jqxGrid>
            </div>
        </div>
    </div>
</jqxWindow>